import { z } from "zod";

// id 열은 uuid 다 — 모양이 아니면 PostgREST 가 22P02 로 죽으므로 부르는 쪽이 조회 없이 「없음」 으로 돌린다.
export const isUuid = (id: string): boolean => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);

// 입력 id 칸 — uuid 모양이 아니면 조회 없이 「없음」 문구로.
export const idSchema = (missing: string) => z.string().trim().min(1, missing).refine(isUuid, missing);
